import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  selectItemById,
  selectItemsIds,
  selectPagination,
  selectRequestState,
  sendRequest,
  changeDefaultQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import PromotionalMaterialsFromUserListItem from './PromotionalMaterialsFromUserListItem';
import MediumPreLoader from '../../Common/PreLoaders/MediumPreLoader';

class PromotionalMaterialsFromUserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultQueryParams: {
        img_resolution: '',
        is_animation: ''
      }
    };
    this.props.changeDefaultQueryParams(this.state.defaultQueryParams);
    this.props.sendRequest();
  }

  render() {
    let items = null;
    if (this.props.requestState.inProgress) {
      items = <MediumPreLoader />;
    } else if (this.props.itemsIds.length > 0) {
      items = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            <PromotionalMaterialsFromUserListItem
              key={`promMat-${itemId}`}
              item={this.props.selectItemById(itemId)}
            />
          ))}
        </React.Fragment>
      );
    } else {
      items = (
        <div className="row">
          <div className="col-xs-24">
            <div className="alert alert-default text-center">
              <p>
                {t(
                  'Рекламные материалы, соответствующие вашим требованиям, не найдены'
                )}{' '}
                :-(
              </p>
            </div>
          </div>
        </div>
      );
    }
    return <div>{items}</div>;
  }
}

PromotionalMaterialsFromUserList.propTypes = {
  // CONNECT
  changeDefaultQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, props.listReduceName),
  pagination: selectPagination(state, props.listReduceName),
  itemsIds: selectItemsIds(state, props.listReduceName),
  selectItemById: id => selectItemById(state, props.listReduceName, id)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PromotionalMaterialsFromUserList);



// WEBPACK FOOTER //
// ./src/components/PromotionalMaterials/PromotionalMaterialsListFromUser/PromotionalMaterialsFromUserList.js